<template>
  <v-card tile :color="config.background" :dark="config.dark">
    <div class="text-center text-h2 font-weight-bold">{{ information.amount }}</div>
    <v-card-text class="text-center subtitle-1">
      {{ information.name }}
    </v-card-text>
    <div :class="`d-block text-center font-weight-bold ${config.background_dark}`">
      <v-btn class="" plain :dark="config.dark" block>
        Ver Info <v-icon right>mdi-arrow-right-bold-circle</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'Indicator-Card',
  props: ['config'],
  data: () => ({
    configuration: {
      background: 'light-green darken-3',
      background_dark: 'light-green darken-4',
      dark: false
    },
    information: {
      name: '',
      amount: 30
    }
  }),
  created () {
    if (this.config) {
      this.configuration = this.config
      this.information = this.config.data
    }
  }
}
</script>

<style>

</style>
